import * as React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { deletebannerDispatch } from 'reducers/HomeReducer';

export default function FlightTable() {
	const { search } = useSelector((state) => state.home);

	const dispatch = useDispatch();
	const columns = [
		{ field: 'orderId', headerName: 'ORDERID', width: 150 },
		{ field: 'originAirportCode', headerName: 'ORIGIN', width: 150 },
		{ field: 'destinationAirportCode', headerName: 'DESTINATION', width: 150 },
		{ field: 'flightType', headerName: 'FlightType', width: 150 },
		{ field: 'agent_id', headerName: 'Agent Id', width: 150 },
		{ field: 'departureDate', headerName: 'Departure Date', width: 150 },
		{ field: 'adults', headerName: 'Adults', width: 150 },
		{ field: 'childs', headerName: 'Childs', width: 150 },
		{ field: 'infants', headerName: 'Infants', width: 150 },
		{
			field: 'updated_at',
			headerName: 'Search On',
			width: 600,
			editable: true,
		},
	];
	const handleClick = (event, cellValues) => {
		console.log('id', cellValues.id);
	};
	const handleClickDelete = (event, cellValues) => {
		console.log('id', cellValues.id);
		dispatch(deletebannerDispatch(cellValues.id, loginInfo.token));
	};
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			{search && search?.result.length > 0 ? (
				<DataGrid
					rows={search?.result}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 5,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
		</Box>
	);
}
